export default {
      id: "i-info-advantages-02-usage",
      viewBox: "0 0 32 28",
      url: __webpack_public_path__ + "img/sprite.svg#i-info-advantages-02",
      toString: function () {
        return this.url;
      }
    }